import React, { FC, useCallback, useState } from 'react';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';

import Card from '@components/elements/Card';
import { PlusIcon } from '@components/elements/Icons';
import Dialog from '@components/elements/Dialog';
import InputText from '@components/elements/InputText';
import RepresentativeList from '@components/modules/Admin/Representative/List';

import { assignRepresentative } from '@sdk/managers/UsersManager';
import { useAuth } from '@hooks/Auth';
import { mutate } from 'swr';

const AdminRepresentativesPage: FC = () => {
  const { dbUser, company } = useAuth();
  const [modal, setModal] = useState<boolean>(false);
  const hideModal = useCallback(() => setModal(false), [setModal]);
  // const showModal = useCallback(() => setModal(true), [setModal]);

  const [newEmail, setNewEmail] = useState<string>();

  const submitAddRepresentative = async (email: string) => {
    try {
      if (!dbUser?.id || !dbUser?.username || !company) {
        throw new Error('Unexpected error.');
      }

      console.log('assignRepresentative', email, company.companyID, dbUser.id);
      const res = await toast.promise(
        assignRepresentative(email, company.companyID, dbUser.id),
        {
          loading: 'Adding representative...',
          success: 'Successfully added representative',
          error: 'Failed to add representative',
        }
      );

      await mutate(['/admin/representatives', company.companyID]);
      console.log('assignRepresentative res', res);
    } catch (err: any) {
      console.log('Failed assignRepresentative', err);
    }
  };

  return (
    <React.Fragment>
      <Dialog
        className="text-center text-black bg-yellow"
        title="Add representative"
        content={
          <div>
            <p className="mb-4 text-sm">
              Enter representative&apos;s email here
            </p>
            <InputText
              name="email"
              type="email"
              placeholder="Email"
              onChange={(value: string) => setNewEmail(value)}
              value={newEmail || ''}
            />
          </div>
        }
        open={modal}
        onCancel={hideModal}
        onConfirm={() => {
          if (newEmail && newEmail.length > 0) {
            submitAddRepresentative(newEmail);
          }
          setNewEmail(undefined);
          hideModal();
        }}
      />
      <div className="flex flex-col min-h-screen px-4 pt-16 pb-32 space-y-4 bg-blue-light">
        <div>
          <h1 className="text-4xl text-white whitespace-pre-line">{`Assign 
        Representatives`}</h1>
          <p className="mt-4 text-sm text-white">
            Update the list of representatives for your Organization
          </p>
        </div>
        <div>
          <Link to="/admin/members">
            <div role="button" className="flex p-4 text-black bg-yellow ">
              <PlusIcon className="mr-2" />
              Add new company member
            </div>
          </Link>
        </div>
        <h2 className="text-white uppercase">COMPANY REPRESENTATIVES</h2>
        <Card shadowColor="yellow" className="p-4 text-center">
          <RepresentativeList />
        </Card>
      </div>
    </React.Fragment>
  );
};

export default AdminRepresentativesPage;
